const colors = {
    primaryColor : '#000000',
    adminColor : '#000000',
    studentColor : '#00366dff',
    landLordColor : '#001800ff',
}
export default colors;